import img1 from "../assets/web/img1.png";
import img2 from "../assets/works/ma/ma_new.png";
import img3 from "../assets/web/img3.png";
import img4 from "../assets/web/img4.png";
import img5 from "../assets/works/lam/lam6.png";
import img6 from "../assets/works/xc/x_new.png";
import img7 from "../assets/web/img7.png";
import img8 from "../assets/web/img8.png";
import img9 from "../assets/web/img9.png";
import img10 from "../assets/web/img10.png";
import img11 from "../assets/works/ca/ca_new.png";
import img12 from "../assets/works/ka/ka1.png"
import img13 from "../assets/web/img13.png";
import img14 from "../assets/works/ch/ch1.png";
import img15 from "../assets/works/gi/gi1.png";
import img16 from "../assets/web/img14.png";
import img17 from "../assets/web/img17.png";
import img18 from "../assets/web/img18.png";
import img19 from "../assets/works/sh/sh1.png";
import img20 from "../assets/works/si/si1.png";
import img21 from "../assets/works/no/no1.png";

const projects = [
  {
    img: img1,
    id: 0,
    name: "Amba Motors - (Garage)",
    link: "ambamotors",
    category: "mernbackendfullstack",
  },
  {
    img: img2,
    id: 1,
    name: "Made by me - ",
    link: "madebyme",
    category: "mernbackendfullstack",
  },
  {
    img: img13,
    id: 13,
    name: "Blog me",
    link: "blogme",
    category: "mernbackendfullstack",
  },
  {
    img: img14,
    id: 14,
    name: "ChatApp (Social media)",
    link: "chatapp",
    category: "mernbackendfullstack",
  },
  {
    img: img15,
    id: 15,
    name: "Github-Clone",
    link: "github",
    category: "mernbackendfullstack",
  },
  {
    img: img16,
    id: 16,
    name: "Maps",
    link: "maps",
    category: "frontend",
  },
  {
    img: img17,
    id: 16,
    name: "Smart Contract Bounding",
    link: "smartcontract",
    category: "frontend",
  },
  {
    img: img18,
    id: 17,
    name: "Admin Pannel",
    link: "adminpannel",
    category: "frontendbackend",
  },
  {
    img: img19,
    id: 18,
    name: "Shopify",
    link: "shopify",
    category: "frontendbackend",
  },
  {
    img: img20,
    id: 19,
    name: "Ecommerce Invoice",
    link: "invoice",
    category: "frontend",
  },
  {
    img: img21,
    id: 20,
    name: "Nodes",
    link: "nodes",
    category: "frontend",
  },
  {
    img: img11,
    id: 2,
    name: "Carnival (Social media)",
    link: "carnival",
    category: "mernbackendfullstack",
  },
  {
    img: img12,
    id: 12,
    name: "KAFF (Foodie)",
    link: "kaff",
    category: "mernbackendfullstack",
  },
  {
    img: img9,
    id: 3,
    name: "Persistence(Employee Management System)",
    link: "persistence",
    category: "fullstacksqlbackend",
  },

  {
    img: img3,
    id: 4,
    name: "Fortnite | Create, Play ,Build ",
    link: "fornite",
    category: "frontend",
  },
  {
    img: img4,
    id: 5,
    name: "Disney Plus (India)",
    link: "disneyplus",
    category: "frontend",
  },
  {
    img: img5,
    id: 6,
    name: "Automobili | Lamborghini ",
    link: "lamborghini",
    category: "frontend",
  },
  {
    img: img6,
    id: 7,
    name: "Xcrypto ",
    link: "xcrypto",
    category: "frontendapi",
  },
  {
    img: img7,
    id: 8,
    name: "Netflix - Watch TV Shows Online",
    link: "netflix",
    category: "frontend",
  },
  {
    img: img8,
    id: 9,
    name: "Pokemon",
    link: "pokemon",
    category: "frontendapi",
  },

  {
    img: img10,
    id: 10,
    name: "Tesla: Electric Cars, Solar",
    link: "tesla",
    category: "frontend",
  },
];

export default projects;
